import { type AxiosInstance } from "axios";
import * as Sentry from "@sentry/react";
import { transferEligibilityResponseSchema } from "@/features/salesforceIntegration/schemas/transferEligibility";
import { type TransferEligibilityResponse } from "@/features/salesforceIntegration/types";

export const TRANSFER_ELIGIBILITY_ENDPOINT =
  "/salesforce/data-transfers/eligibility/";

/**
 * 契約検証。OpenAPIからの型生成が無いため、実行時検証で契約の崩れを検知する
 * （`useAcquireBookStatus.ts`の前例に倣う）。
 */
const validateResponse = (payload: unknown): TransferEligibilityResponse => {
  const parsed = transferEligibilityResponseSchema.safeParse(payload);
  if (parsed.success) {
    return parsed.data;
  }

  const error = new Error(
    `API contract violation at ${TRANSFER_ELIGIBILITY_ENDPOINT}`
  );
  Sentry.captureException(error, {
    extra: { issues: parsed.error.issues },
  });
  throw error;
};

export interface GetTransferEligibilityParams {
  pictureRequestIds: number[];
  /** 詳細画面のみ`true`を指定し、物件単位の可否も取得する。 */
  includeRealEstates?: boolean;
}

/**
 * 連携可否の判定結果を取得する（`GET /salesforce/data-transfers/eligibility/`）。
 * 判定ロジックはバックエンドに1つだけ置かれており、フロントエンドは結果をそのまま表示に使う。
 */
export const getTransferEligibility = async (
  apiClient: AxiosInstance,
  params: GetTransferEligibilityParams
): Promise<TransferEligibilityResponse> => {
  const { data } = await apiClient.get<unknown>(TRANSFER_ELIGIBILITY_ENDPOINT, {
    params: {
      pictureRequestIds: params.pictureRequestIds.join(","),
      ...(params.includeRealEstates ? { includeRealEstates: true } : {}),
    },
  });
  return validateResponse(data);
};
